import BootTextField from "components/common/custom/forms/BootTextField";
import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import paths from "routes/paths";
import { ForgotPassword } from "../config/AuthApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setForgotData } from "../config/AuthSlice";
import { AES } from "crypto-js";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
const ForgetPasswordForm = () => {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const handleForgotPassword = async (data) => {
    setLoading(true);
    const sensitiveData = "user123";
    const secretKey = "asdjh23kjasdjkashdkjh23kjh4";

    const encryptedData = AES.encrypt(sensitiveData, secretKey).toString();
    const encryptedQueryString = `?data=${encryptedData}`;
    const finalURL = `${window.location.origin}${paths.resetPassword}/endpoint${encryptedQueryString}`;

    const { email } = data;

    const response = await dispatch(
      ForgotPassword({ email, slink: finalURL })
    ).unwrap();

    if (response?.success) {
      toast.success(response?.message_en || response?.message_ar);
      navigate(paths.confirmMail, { replace: true });
      dispatch(setForgotData({ email, finalURL }));
      setLoading(false);
    } else {
      toast.error(response?.message_en || response?.message_ar);
      setLoading(false);
    }
  };
  return (
    <Form className="mt-4" onSubmit={handleSubmit(handleForgotPassword)}>
      <Form.Group className="mb-3">
        <TextInput
          name="email"
          control={control}
          type="email"
          placeholder="Email address"
          errors={errors}
          isRequired
          rules={{
            required: true,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          }}
        />
        {errors?.email && (
          <Form.Control.Feedback type="invalid" className=" w-full">
            {errors?.email?.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={loading}>
          {loading ? (
            <Spinner size={"sm"} animation="border" />
          ) : (
            "Send Reset Link"
          )}
        </Button>
      </Form.Group>
      <Form.Group className="mb-3">
        <Button
          className="w-100"
          type="button"
          variant="outline-secondary"
          onClick={() => navigate(paths.login)}
        >
          Return to Login
        </Button>
      </Form.Group>
    </Form>
  );
};

export default ForgetPasswordForm;
